import { render, staticRenderFns } from "./healthData.vue?vue&type=template&id=77f9e186&scoped=true&"
import script from "./healthData.vue?vue&type=script&lang=js&"
export * from "./healthData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f9e186",
  null
  
)

export default component.exports